/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 14:55:14
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-26 15:50:53
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServiceError } from "../services/errors";
import * as R from "../services/request";
import { Request } from "../services/request";
import { AppDispatch, RootState } from "./store";

export const CREDENTIALS_KEY = "supervisor_credentials";

interface Credentials {
  userId: string;
  userName: string;
  token: string;
  regionCode?: string;
  regionName?: string;
  roleType?: number;
}

interface AppError {
  code: number;
  message: string;
}

interface AppState {
  credentials?: Credentials;
  appError?: AppError;
}

const initialState = {
  credentials: (function (): Credentials | undefined {
    const json = localStorage.getItem(CREDENTIALS_KEY);
    if (json) {
      try {
        return JSON.parse(json);
      } catch {
        // do nothing.
      }
    }
    return undefined;
  })(),
} as AppState;

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<Credentials | undefined>) => {
      state.credentials = action.payload;
      if (action.payload) {
        localStorage.setItem(CREDENTIALS_KEY, JSON.stringify(action.payload));
      } else {
        localStorage.removeItem(CREDENTIALS_KEY);
      }
    },
    setAppError: (state, action: PayloadAction<AppError | undefined>) => {
      state.appError = action.payload;
    },
    Logout(state, action) {
      localStorage.removeItem(CREDENTIALS_KEY);
      state.credentials = action.payload;
    },
  },
});

function setCommonHeaders(
  request: Request,
  getState: () => RootState
): Request {
  const creds = getState().app.credentials;
  const headers = request.headers || {};
  return {
    ...request,
    headers: creds ? { ...headers, "HIS-Auth": creds.token } : headers,
  };
}

export async function send(
  request: Request,
  {
    getState,
    dispatch,
  }: {
    getState: () => RootState;
    dispatch: AppDispatch;
  },
  ignoreError = false
): Promise<any> {
  return R.send(setCommonHeaders(request, getState)).catch((e) => {
    const error =
      e instanceof ServiceError
        ? {
            code: e.code,
            message: e.message,
          }
        : { code: 500, message: e.message };
    if (error.code === 401) {
      dispatch(setCredentials(undefined));
    } else if (!ignoreError) {
      dispatch(setAppError(error));
    }
    throw e;
  });
}

export const { setCredentials, setAppError, Logout } = appSlice.actions;

export const selectLoginState = (state: RootState): boolean =>
  !!state.app.credentials;

// export const selectLoginStatus = (state: RootState): RootState => state.app.loginStatus;
export const selectAppError = (state: RootState): AppError | undefined =>
  state.app.appError;

export const selectAppRegionCode = (state: RootState): any =>
  state.app.credentials?.regionCode;

export const selectAppRegionName = (state: RootState): any =>
  state.app.credentials?.regionName;

export const selectApproleType = (state: RootState): any =>
  state.app.credentials?.roleType;

export default appSlice.reducer;
